import Component from "../classes/Component";
import {$dom} from "../helpers/dom";
import {$events} from "../helpers/events";
import variables from "../variables";

const {addClass, removeClass, get, hasClass, getAll} = $dom

const groupSelector = '.js-header-search-group'
const inputSelector = '.js-header-search-input'
const iconSearchSelector = '.js-header-icon-search'
const iconCloseSelector = '.js-header-icon-close'

export default function () {
    const headerInput = getAll(inputSelector);
    const headerSearch = getAll(groupSelector);

    const headerLink = get('.header__link-wrapper');
    const dropdown = getAll('.dropdown__wrapper-click .dropdown')

    const handleField = e => {
        const searchIcon = getAll(iconSearchSelector)
        const closeIcon = getAll(iconCloseSelector)

        searchIcon.forEach(item => {
            if (e.target.value.length > 0) {
                addClass(item, variables.classNames.hidden)
            } else {
                removeClass(item, variables.classNames.hidden)
            }
        })

        closeIcon.forEach(item => {
            if (e.target.value.length > 0) {
                removeClass(item, variables.classNames.hidden)
            } else {
                addClass(item, variables.classNames.hidden)
            }
        })

        dropdown.forEach(item => {
            addClass(item, variables.classNames.visible)
        })
    }

    const handleClear = (e) => {
        headerInput.forEach(item => {
            item.value = ''
            item.focus()
        })

        addClass(e.target, variables.classNames.hidden)
        removeClass(e.target.previousElementSibling, variables.classNames.hidden)
    }

    const handleClickBody = (e) => {
        if (e.target.closest('.dropdown__wrapper-click')) {
            headerInput.forEach(item => {
                item.focus()
            })
        } else {
            setTimeout(() => {
                removeClass(headerLink, variables.classNames.hidden)
            }, 400)

            dropdown.forEach(item => {
                removeClass(item, variables.classNames.visible)
            })

            removeClass(headerSearch, 'header__search--width_max')
        }
    }

    const handleFocus = () => {
        addClass(headerLink, variables.classNames.hidden)

        headerSearch.forEach(item => {
            addClass(item, 'header__search--width_max')
        })

        $events.delegate.on('click', 'body', handleClickBody)
    }

    const handleBlur = (e) => {
        if (e.target.value.length === 0) {
            setTimeout(() => {
                removeClass(headerLink, variables.classNames.hidden)
            }, 400)
            removeClass(dropdown, variables.classNames.visible)

            headerSearch.forEach(item => {
                removeClass(item, 'header__search--width_max')
            })
        }

        // if (!hasClass(dropdown, variables.classNames.visible)) {
        //     removeClass(dropdown, variables.classNames.visible)
        //     $events.delegate.off('click', 'body', handleClickBody)
        // }
    }

    return new Component({
        name: 'headerSearch',
        requiredTargets: [groupSelector, inputSelector, iconSearchSelector, iconCloseSelector],
        onInit() {
            $events
                .add('focus', inputSelector, handleFocus)
                .add('blur', inputSelector, handleBlur)
                .delegate
                .on('input', inputSelector, handleField)
                .on('click', iconCloseSelector, handleClear)

        },
        onDestroy() {
            $events
                .remove('focus', inputSelector, handleFocus)
                .remove('blur', inputSelector, handleBlur)
                .delegate
                .off('input', inputSelector, handleField)
                .off('click', iconCloseSelector, handleClear)

        },
    })

}